import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useQuery, useQueryClient } from "react-query";
import debounce from "lodash.debounce";

import { getUaSettings } from "../../api";
import { ALLOWED_APPS_OPTIONS, DEFAULT_APPS, DEFAULT_TABS } from "../../config";
import _ from "../../i18n";

import Pagination from "../common/Pagination";
import Loader from "../common/Loader";

import ConfigModal from "./ConfigModal";
import styles from "./ManageApps.module.scss";

const ConfigTab = ({ showConfigModal, setShowConfigModal }) => {
  const queryClient = useQueryClient();
  const auth = useSelector((state) => state.auth);
  const { token } = auth;
  const [searchName, setSearchName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({
    property: "createdAt",
    dir: "desc",
  });
  // const [showConfigModal, setShowConfigModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const LIMIT = 10;

  let { isLoading, data } = useQuery(
    ["listUaSettings", token, searchName, sort, currentPage],
    async () => {
      if (token) {
        try {
          const response = await getUaSettings({
            token,
            page: currentPage,
            limit: LIMIT,
            sort,
            title: searchName,
          });

          return response.data;
        } catch (e) {
          return [];
        }
      }
    }
  );

  const handleSearchChange = (e) => {
    debouncedLoadResults(e.target.value);
  };

  const debouncedLoadResults = debounce((search) => {
    setSearchName(search);
  }, 1000);

  const renderApps = (item) => {
    let tabAllowedApps = [];
    if (item.allowedApps) {
      item.allowedApps.forEach((i) => {
        const row = ALLOWED_APPS_OPTIONS.find((j) => j.value === i);
        if (row) {
          tabAllowedApps.push(row);
        }
      });
    } else {
      tabAllowedApps = ALLOWED_APPS_OPTIONS.filter(
        (i) => i && DEFAULT_APPS.includes(i.value)
      );
    }
    return (
      <div className={styles.apps}>
        {tabAllowedApps.map((app) => {
          return (
            <div className={styles.apps_item}>
              <div className={styles.apps_item_icon}>
                <img src={`img/apps/${app.icon}`} alt="" />
                <span>{app.name}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderTabs = (item) => {
    let tabAllowedTabs = [];
    if (item.allowedTabs) {
      tabAllowedTabs = [...item.allowedTabs];
    } else {
      tabAllowedTabs = [...DEFAULT_TABS];
    }
    return (
      <div className={styles.apps}>
        {tabAllowedTabs.map((tab) => {
          return (
            <div className={styles.tabs_item}>
              <span>{tab}</span>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className={styles.filterBar}>
        <span></span>
        <div className={styles.inputSearch}>
          <span className={styles.inputSearch_icon}>
            <i className="icon-ttp-magnifier"></i>
          </span>
          <input
            type="text"
            placeholder={_("search")}
            onChange={(e) => handleSearchChange(e)}
          />
        </div>
      </div>

      <table className={`${styles.table} unstriped`}>
        <thead>
          <tr>
            <th width="30%" className={styles.nowrap}>
              <span>{_("title")}</span>
              <span className={styles.sortBox}>
                <i
                  className={`icon-ttp-arrow-down ${
                    sort.property === "title" &&
                    sort.dir === "asc" &&
                    styles.iconActive
                  }`}
                  onClick={() => setSort({ property: "title", dir: "asc" })}
                ></i>
                <i
                  className={`icon-ttp-arrow-up ${
                    sort.property === "title" &&
                    sort.dir === "desc" &&
                    styles.iconActive
                  }`}
                  onClick={() => setSort({ property: "title", dir: "desc" })}
                ></i>
              </span>
            </th>
            <th width="20%">Apps</th>
            <th width="30%">Tab space</th>
            <th width="20%">Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={6} className={styles.centerCell}>
                <Loader
                  style={{
                    height: "10px",
                  }}
                  color={"#B2BCC6"}
                />
              </td>
            </tr>
          ) : data?.data && data.data.length > 0 ? (
            data.data.map((item) => {
              return (
                <tr key={item.id}>
                  <td>
                    {item.title}{" "}
                    {item.isDefault && (
                      <span className={styles.default_tag}>Default</span>
                    )}
                    {item.isUniversity && (
                      <span className={styles.default_tag}>University</span>
                    )}
                  </td>
                  <td>{renderApps(item)}</td>
                  <td>{renderTabs(item)}</td>
                  <td>{item.createdAt}</td>
                  <td>
                    <span
                      className={`${styles.action} icon-ttp-pencil`}
                      onClick={(e) => {
                        setCurrentItem(item);
                        setShowConfigModal(true);
                      }}
                    />
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={6} className={styles.centerCell}>
                Liste vide (aucune fiduciaire ne répond aux filtres)
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {data?.nbResult && (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={data.nbResult}
          pageSize={LIMIT}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
      <ConfigModal
        modalOpen={showConfigModal}
        setModalOpen={setShowConfigModal}
        currentItem={currentItem}
        setCurrentItem={setCurrentItem}
        refreshList={() => queryClient.invalidateQueries("listUaSettings")}
      />
    </>
  );
};

export default ConfigTab;
